module.exports = __webpack_public_path__ + "img/y.e7db5dd5.jpg";